import { makeContextModule } from '@cian/react-utils';

import { type TCardApiContext } from '@/microfrontends/listing/shared/types/TCardApiContext';

export const {
  Context: { Provider: CardApiContextProvider },
  useContext: useCardApiContext,
} = makeContextModule<TCardApiContext>({
  contextName: 'CardApiContext',
});
